import type { PublicChatApiResponse } from './types';

/**
 * POST target: production `https://chat.geofleet.ai/public/chat`.
 * For localhost, set `VITE_PUBLIC_CHAT_API_URL=/api/geofleet-chat` (Vite proxies — see vite.config.ts).
 */
export function getPublicChatApiUrl(): string {
  const fromEnv = (import.meta.env.VITE_PUBLIC_CHAT_API_URL as string | undefined)?.trim();
  if (fromEnv) return fromEnv;
  return 'https://chat.geofleet.ai/public/chat';
}

/**
 * Sends the visitor message to Geofleet public chat.
 * Body: `{ message, session_id }` — same `session_id` for the whole conversation until cleared.
 */
export async function postPublicChat(message: string, sessionId: string): Promise<PublicChatApiResponse> {
  const url = getPublicChatApiUrl();
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ message, session_id: sessionId }),
  });

  const text = await res.text();
  let data: PublicChatApiResponse = {};
  try {
    data = text ? (JSON.parse(text) as PublicChatApiResponse) : {};
  } catch {
    throw new Error('invalid_json');
  }

  if (!res.ok) {
    throw new Error(data && typeof (data as { error?: string }).error === 'string' ? (data as { error: string }).error : `http_${res.status}`);
  }

  return data;
}
